import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import Global from '../../../store/global-selectors';
import * as CSWActions from '../../../store/csw/csw.actions';
import * as Actions from '../../../store/customers/create-label/customers.create-label.actions';
import * as CreateLabelActions from '../../../store/create-label-content/create-label-content.actions';
import * as RateBrowserActions from '../../../store/rate-browser/rate-browser.actions';
import { PackageService } from '../../../services/package-service';

export const launchCustomerCreateLabelModal = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.LAUNCH_CUSTOMERS_CREATE_LABEL_MODAL),
    mergeMap(() => {
      const state = getState();
      const shipFromId = Global.selectSellerDefaultShipFromId(state);
      const sellerPackages = Global.selectSellerPackages(state);
      const standardPackageTypeId = PackageService.getStandardPackageId().toString();
      const selectedPackage = sellerPackages.find((p) => p.packageTypeId === standardPackageTypeId);
      const shipToCountryCode = Global.selectSellerSupportCountry(state);
      const sellerLabelProviderId = '';
      const rate = {};
      const defaultRatesConfig = {
        shipFromId,
        ...selectedPackage,
        shipToCountryCode,
      };
      return of(
        Actions.updateConfigureRatesModel(defaultRatesConfig),
        CreateLabelActions.configureLabel(sellerLabelProviderId, rate, 'customers-create-label'),
      );
    }),
  );
};

export const closeCustomerCreateLabelModal = (action$) => {
  return action$.pipe(
    ofType(Actions.CLOSE_CUSTOMERS_CREATE_LABEL_MODAL),
    mergeMap(() => {
      return of(RateBrowserActions.resetRateBrowserModal(), CSWActions.resetCSW('customers-create-label'));
    }),
  );
};
